module.exports = "https://www.gc-qa.gnp.com.mx/83edd491645568152eb11a79138ba286.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_vida_off.svg
// module id = 696
// module chunks = 0